export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web Development',
        startYear: '2021',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'GITA autonomus college, Bhubaneswar',
        course: `Bachlore's in Electrical and Elecetronics`,
        startYear: '2017',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Jupiter Science College, Bhubaneswar',
        course: 'intermediate',
        startYear: '2015',
        endYear: '2017'
    }
]